export default __webpack_public_path__ + "static/media/Assessments.2acecc66.svg";